import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import IconDowload from "../../Resources/svg/Icons/IconDowload";
import IconTableDown from "../../Resources/svg/Icons/IconTableDown";
import Button from "./Button";
import Flags from "./Flags";

import {
  addClient,
  addHealthStatement,
  addWorkData,
  addBeneficiary,
} from "../../Store/simulate/actions";
import { decryptEstandar } from "../../Utils/CryptographyUtils";
import { formatNumber, getPdfSimulacion } from "../../Utils/utils";
import { generatePdfSimulateAS } from "../../Services/GeneratePdfSimulateAS";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import Loading from "../loading";

interface Props {
  data: any;
  codProd: any;
  activeProduct: any;
}

const CardTabla = ({ data, codProd, activeProduct }: Props) => {
  const [isLoading, setIsLoading] = useState<any>(false);
  const [linkPdf, setLinkPdf] = useState("");
  const elem: any = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const asesor = useSelector((state: any) =>
    decryptEstandar(state.login.username)
  );

  const [collapse, setCollapse] = useState(false);
  const {
    estado,
    numSimulacion,
    fechaCreacion,
    datosCliente: { nombres, documento },
    datosSimulacion: {
      prima,
      tasa,
      vencimiento,
      moneda,
      primaBase,
      primaAhorro,
      sumaAsegurada,
    },
  } = data;

  const onClickCotizar = (item: any) => {
    let rutas: any = {
      IG: "/cotizaciones/datos-personales",
      AS: "/cotizaciones/datos-personales",
      UC: "/cotizaciones/datos-personales",
      RG: "/cotizaciones/datos-personales",
      // AS: "/simulaciones/datos-cliente",
    };

    dispatch(addClient(item));

    history.push(rutas[item.producto.codigo]);

    window.digitalData.push({
      action: {
        group: "Simulaciones",
        category: "Listado",
        name: activeProduct,
        label: "Cotizar",
      },
      event: "trackAction",
    });
  };

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  const generatePdfSimulate = async (data: any) => {
    setIsLoading(true);
    if (data.producto.codigo == "IG" || data.producto.codigo == "UC") {
      const response = await API.get(
        "api-rentas",
        "/generate-pdf/" + data.idSimulacion,
        data.idSimulacions
      );

      if (response.status) {
        setLinkPdf(response.data);
      }

      setIsLoading(false);
    } else if (data.producto.codigo == "AS") {
      setIsLoading(false);
      return generatePdfSimulateAS(data);
    } else if (data.producto.codigo == "RG") {
      const rowData = [{idQuote: data.idSimulacion}];
      const response = await getPdfSimulacion("RG", rowData)
      if (response.status) {
        setLinkPdf(response.data);
      } else {
        console.log(response.message)
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <div className="card-table">
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <div>
        <Flags variant={estado}>{estado}</Flags>
      </div>
      <div className={`card-table__icon`} onClick={handleCardStateTable}>
        <IconTableDown className={`${collapse ? "up" : "down"}`} />
      </div>
      <div className="card-table__box">
        <div className="card-table__description">Nº de simulación:</div>
        <div className="card-table__data">{numSimulacion}</div>
        <div className="card-table__description">Fecha:</div>
        <div className="card-table__data">{fechaCreacion}</div>
        <div className="card-table__description">Contratante:</div>
        <div className="card-table__data">{getTitleCase(nombres)}</div>
        {collapse && (
          <>
            <div className="card-table__description">DNI/CE:</div>
            <div className="card-table__data">{documento}</div>
            <div className="card-table__description">Prima comercial:</div>
            <div className="card-table__data">
              {moneda && moneda.simbolo} {formatNumber.new(prima)}
            </div>
            {codProd == "IG" ? (
              <>
                <div className="card-table__description">Prima base:</div>
                <div className="card-table__data">
                  {moneda && moneda.simbolo} {formatNumber.new(primaBase)}
                </div>
                <div className="card-table__description">Prima ahorro:</div>
                {moneda && moneda.simbolo} {formatNumber.new(primaAhorro)}
              </>
            ) : codProd === "UC" ? (
              <>
                <div className="card-table__description">Suma Asegurada</div>
                <div className="card-table__data">
                  {moneda && moneda.simbolo} {formatNumber.new(sumaAsegurada)}
                </div>
              </>
            ) : (
              tasa !== null && (
                <>
                  <div className="card-table__description">Tasa:</div>
                  <div className="card-table__data">{tasa}%</div>
                </>
              )
            )}

            <div className="card-table__description">Vencimiento:</div>
            <div className="card-table__data">{vencimiento}</div>
          </>
        )}
        {estado !== "Vencida" && ["AS", "IG", "UC", "RG"].includes(codProd) && (
          <>
            <Button
              className="is-secondary"
              onClick={() => onClickCotizar(data)}
              disabled={
                estado === "Vencida" || !["AS", "IG", "UC", "RG"].includes(codProd)
              }
            >
              Cotizar
            </Button>

            <div
              className="card-table__download"
              onClick={() => generatePdfSimulate({ ...data, asesor })}
            >
              <div>Descargar</div>
              <IconDowload />
            </div>
          </>
        )}
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default CardTabla;
